import './App.css';
import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Table,Button,Header,Container,Radio,Segment,Icon,Grid,Popup } from 'semantic-ui-react';
import Filters from './Filters';
// import {HttpsProxyAgent} from 'https-proxy-agent';
// const nfetch = require('node-fetch');

class App extends React.Component {

  constructor(){
    super();
    this.keyCount=0;
    this.proxifly = new (require('proxifly'))({apiKey:'Ar9MMv9khDaNULgzDte7bQPSER82Emo1madQB8rQassE'});
    // this.today = new Date("2021","04","07");
    this.today = new Date();
    this.dd = parseInt(String(this.today.getDate()).padStart(2, '0'));

    this.state = {
        pin: localStorage.getItem("pin") != null ? localStorage.getItem("pin") : "",
        cols:"",
        rows:"",
        isAudioPlaying:false,
        alertOn:true,
        selFilter: localStorage.getItem("filter") != null ? localStorage.getItem("filter") : "pincode",
        selState: localStorage.getItem("state") != null ? localStorage.getItem("state") : "",
        selDistrict: localStorage.getItem("district") != null ? localStorage.getItem("district") : "",
        selStateName: localStorage.getItem("stateName") != null ? localStorage.getItem("stateName") : "",
        selDistrictName: localStorage.getItem("districtName") != null ? localStorage.getItem("districtName") : "",
        isAgeFilter:false,
        ageFilter:"",
        isFeeFilter:false,
        feeFilter:"",
        isVaccineFilter:false,
        vaccineFilter:"",
    };

  } 

  // because im a idiot and thought i'd need proxy to overcome api rate limit in production
  // getProxy = async () =>{
  //   let proxy;
  //   await fetch("https://api.proxifly.com/get-proxy",
  //   {
  //     method:"POST",
  //     headers: {
  //       'Content-Type': 'application/json;charset=utf-8'
  //     },
  //     body: JSON.stringify({protocol:"http"}),
  //   })
  //   .then(response=>response.json())
  //   .then(json=>{proxy=json["ipPort"]});
  //   // let json = response.json();
  //   return `http://${proxy}`;
  // }

  getDate = (date) =>{
    return `${String(date).padStart(2, '0')}-${String(this.today.getMonth() + 1).padStart(2, '0')}-${this.today.getFullYear()}`;
  }

  fetchData = async() =>{
    // if(proxy!==""){
      // let proxyAgent = new HttpsProxyAgent(proxy);
        
      // to check the public visible ip
      // fetch("https://api.proxifly.com/get-public-ip",{agent:proxyAgent})
      // .then(response=>response.json())
      // .then(json=>console.log(json));
      
      if(this.state.selFilter==="district"){
        if(this.state.selState !== "" && this.state.selDistrict !==""){
          fetch(`https://cdn-api.co-vin.in/api/v2/appointment/sessions/public/calendarByDistrict?district_id=${this.state.selDistrict}&date=${this.getDate(this.dd)}`,{
            method:"GET",
          })
          .then(response => response.json())
          .then(json => {this.createCols(json);this.createRows(json)})
          .catch(e=>console.log("unable to fetch data !, trying again ..."));
        }
      }
      else{
        if(this.state.pin !== "" && this.state.pin.length>=6){
          fetch(`https://cdn-api.co-vin.in/api/v2/appointment/sessions/public/calendarByPin?pincode=${this.state.pin}&date=${this.getDate(this.dd)}`,{
            method:"GET",
          })
          .then(response => response.json())
          .then(json => {this.createCols(json);this.createRows(json)})
          .catch(e=>console.log("unable to fetch data !, trying again ..."));
        }
      }
  }

  // creating table headers
  createCols = (json) =>{
    let cols = [];
    let keyCount = 0;
    cols.push(<td key={(++keyCount)*-1}></td>)
    for(let i=0;i<5;i++)
    {
      cols.push(<Table.HeaderCell textAlign="center" key={(++keyCount)*-1}>{this.getDate(this.dd+i)}</Table.HeaderCell>);
    }
    this.setState({cols:cols});
  }

  // creating table rows/cells
  createRows = (json) =>{
    let rows = [];
    let keyCount = 0;
    try {
      let centers = json["centers"]
      
      // 2 - fees filters
      if(this.state.isFeeFilter){
        if(this.state.feeFilter==="free")
          centers = centers.filter(val=>val["fee_type"]==="Free"); //for free
        else
          centers = centers.filter(val=>val["fee_type"]==="Paid"); //for Paid
      }
      
      centers.forEach((element,index)=>{
        let cols = [];
        let fee_type;
        if(element["fee_type"]==="Paid"){
          let tmp = element["vaccine_fees"].map(center=><div className="fees-status paid">{center["vaccine"]} <br/> &#8377; {center["fee"]}</div>);
          fee_type=([...tmp]);
        }
        else{
          fee_type = (<div className="fees-status">{element["fee_type"]}</div>);
        }
        cols.push(
            <Table.Cell collapsing textAlign="center" key={++keyCount} className="td-center-name">
              <div>
                <h3>{element["name"]}</h3>
                <p>{element["address"]}</p><br/>
                <p>{element["district_name"]}, {element["state_name"]}, {element["pincode"]}</p>
                {fee_type}
              </div>
            </Table.Cell>
        );

        for(let i=0;i<5;i++){
          let todaysSessions = element["sessions"].filter((val,ind)=>val["date"]===this.getDate(this.dd+i));
          
          // filters
          // 1 - age group filters
          if(this.state.isAgeFilter){
            if(this.state.ageFilter==="44+")
              todaysSessions = todaysSessions.filter(val=>parseInt(val["min_age_limit"])>44); //for ages 44+
            else if(this.state.ageFilter==="18+")
              todaysSessions = todaysSessions.filter(val=> parseInt(val["min_age_limit"])>=18 && parseInt(val["min_age_limit"])<=44); //for ages 18-44
          }
          // 3 - vaccine filters
          if(this.state.isVaccineFilter){
            if(this.state.vaccineFilter==="COVISHIELD")
              todaysSessions = todaysSessions.filter(val=> val["vaccine"] === "COVISHIELD");
            else if(this.state.vaccineFilter==="COVAXIN")
              todaysSessions = todaysSessions.filter(val=> val["vaccine"] === "COVAXIN");
            else if(this.state.vaccineFilter==="SPUTNIK V")
              todaysSessions = todaysSessions.filter(val=> val["vaccine"] === "SPUTNIK V");
          }

          // console.log(todaysSessions.length);
          
          todaysSessions = todaysSessions.map((val,index,sessions)=>{
              let sessionDiv = null;
              if((val["available_capacity_dose1"]+val["available_capacity_dose2"])>0){
                if(this.state.alertOn){
                  try{
                    document.querySelector("#audio").play();
                    this.setState({"isAudioPlaying":true});
                  }
                  catch(e){}
                }
                let dose1=null,dose2=null;
                val["available_capacity_dose1"] > 0 ? dose1 = (<h3> <Icon name='checkmark'/> Dose 1 - {val["available_capacity_dose1"]}</h3>) : dose1 = (<h3> <Icon name='attention' /> Dose 1 - {val["available_capacity_dose1"]}</h3>)
                val["available_capacity_dose2"] > 0 ? dose2 = (<h3> <Icon name='checkmark'/> Dose 2 - {val["available_capacity_dose2"]}</h3>) : dose2 = (<h3> <Icon name='attention' /> Dose 2 - {val["available_capacity_dose2"]}</h3>)
                sessionDiv = (
                <div className="available">
                  {dose1}
                  {dose2}
                  <p>Age {val["min_age_limit"]} +</p>
                  <p>{val["vaccine"]}</p>
                  <a href="https://selfregistration.cowin.gov.in/"><Button color="green">Book</Button></a>
                </div>);
              }else{
                sessionDiv = (
                <div className="booked">
                  <h3> <Icon name='attention' /> Booked</h3>
                  <p>Age {val["min_age_limit"]} +</p>
                  <p>{val["vaccine"]}</p>
                </div>);
              }
              if(index < sessions.length-1){
                return(<div>{sessionDiv}<hr style={{marginTop:"20px",marginBottom:"20px",opacity:"30%"}}/></div>);
              }
              else{
                return(sessionDiv);
              }
          });

          if(todaysSessions.length===0) {
            todaysSessions = [<p>NA<br/></p>]
            cols.push(
              <Table.Cell collapsing textAlign="center" key={++keyCount}>
                {[...todaysSessions]}
              </Table.Cell>
            );
          }
          else{
            // formatting table cells according to vaccine availability
            if(todaysSessions.some(i=>i.props.className==="available" || i.props.children.some(ii=>ii.props.className==="available"))){
                cols.push(
                  <Table.Cell collapsing textAlign="center" data-key={keyCount+1} key={++keyCount} positive>
                    {[...todaysSessions]}
                  </Table.Cell>
                );
              }
            else{
                cols.push(
                  <Table.Cell collapsing textAlign="center" data-key={keyCount+1} key={++keyCount} warning>
                    {[...todaysSessions]}
                  </Table.Cell>
                );
              }
          }
        }

        // do not show NA rows when a filter is applied
        if(this.state.isAgeFilter || this.state.isFeeFilter || this.state.isVaccineFilter){
          if(cols.length !== cols.filter(val=> (val.props["positive"] === undefined && val.props["warning"] === undefined)).length)
          rows.push(<Table.Row>{[...cols]}</Table.Row>);
        }
        else{
          rows.push(<Table.Row>{[...cols]}</Table.Row>);
        }
        
      });

      this.setState({rows:rows});
    } catch (error) {}
  }

  // inputChange = (e) =>{
  //   e.preventDefault();
  //   let pin = document.querySelector("#pin").value;
  //   this.setState({pin:pin});
  //   localStorage.setItem("pin",pin);
  //   this.fetchData();
  // }

  onAlertSnooze = (e) =>{
    document.querySelector("#audio").pause();
    this.setState({alertOn:false,isAudioPlaying:false});
  }

  // for sharing and changing app state from filter
  _setPin = (pin) => {
    this.setState({pin:pin});
  }
  _setFilter = (filter) => {
    this.setState({selFilter:filter});
  }
  _setState = (state) => {
    this.setState({selState:state});
  }
  _setStateName = (stateName) => {
    this.setState({selStateName:stateName});
  }
  _setDistrict = (district) => {
    this.setState({selDistrict:district});
  }
  _setDistrictName = (districtName) => {
    this.setState({selDistrictName:districtName});
  }
  _setIsAgeFilter = (yesNo) => {
    this.setState({isAgeFilter:yesNo});
  }
  _setAgeFilter = (ageFilter) => {
    this.setState({ageFilter:ageFilter});
  }
  _setIsFeeFilter = (yesNo) => {
    this.setState({isFeeFilter:yesNo});
  }
  _setFeeFilter = (feeFilter) => {
    this.setState({feeFilter:feeFilter});
  }
  _setIsVaccineFilter = (yesNo) => {
    this.setState({isVaccineFilter:yesNo});
  }
  _setVaccineFilter = (vaccineFilter) => {
    this.setState({vaccineFilter:vaccineFilter});
  }

  commponentDidUpdate(){
    this.setState({isAudioPlaying:!document.querySelector("#audio").paused});
  }

  componentDidMount(){
    this.fetchData();
    setInterval(() => this.fetchData(), 4000);
  }

  render(){
    if([...this.state.rows].length!==0 || [...this.state.cols].length!==0){
      return (
        <Container fluid className="tableContainer">
        <div className="innerContainer">
        <Grid columns={2} doubling stackable>
          <Grid.Row centered>
          <Grid.Column style={{display:"grid"}}>
          <Segment compact textAlign="center">
            <Filters
                appState={this.state} 
                pin={this.state.pin}
                filter={this.state.selFilter} 
                state={this.state.selState} 
                stateName={this.state.selStateName} 
                district={this.state.selDistrict} 
                districtName={this.state.selDistrictName}
                fetchData = {this.fetchData}
                setState={{filter:this._setFilter,state:this._setState,district:this._setDistrict,stateName:this._setStateName,districtName:this._setDistrictName,pin:this._setPin,isAgeFilter:this._setIsAgeFilter,ageFilter:this._setAgeFilter,isFeeFilter:this._setIsFeeFilter,feeFilter:this._setFeeFilter,isVaccineFilter:this._setIsVaccineFilter,vaccineFilter:this._setVaccineFilter}} 
              />
            </Segment>
            </Grid.Column>
            <Grid.Column style={{display:"grid"}}>
                <Segment compact textAlign="center">
                  <Popup
                    hideOnScroll
                    trigger={
                        <Segment.Group className="controls-alert" compact>
                        <Segment>
                          <Radio label='Alert me here on vaccine available' toggle onChange={()=>this.setState((state)=>({alertOn:!state.alertOn}))} checked={this.state.alertOn}></Radio>
                        </Segment>
                        <Segment>
                          <Button className="btn-alert-snooze" onClick={this.onAlertSnooze} color="olive" disabled={!this.state.isAudioPlaying}>Stop alert</Button>
                        </Segment>
                      </Segment.Group>                  
                    }
                    content="Keep this browser running in background to receive alerts here"
                    position='top right'
                    on="hover"
                  />
                  <Segment>
                    <a href="/groups">
                    <Button color='twitter' size="big">
                      <Icon name='bell'/> Get instant alerts on Telegram
                    </Button>
                    </a>
                  </Segment>
                </Segment>
            </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className="misc" style={{display:"flex",justifyContent:"center"}}>
            <audio id="audio" src="./alert2.mp3" type="audio/mp3"></audio>
          </div><hr/>
          <div className="main-table">
            <Table definition unstackable celled>
              <Table.Header>
                <Table.Row>
                  {[...this.state.cols]}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {[...this.state.rows]}
              </Table.Body>
            </Table>
          </div>
        </div>
        </Container>
      );
    }
    else if(this.state.pin!==""){
      return(
        <Container fluid className="tableContainer">
        <div className="innerContainer">
        <Grid columns={2} doubling stackable>
          <Grid.Row centered>
          <Grid.Column style={{display:"grid"}}>
          <Segment compact textAlign="center">
          <Filters
                appState={this.state} 
                pin={this.state.pin}
                filter={this.state.selFilter} 
                state={this.state.selState} 
                stateName={this.state.selStateName} 
                district={this.state.selDistrict} 
                districtName={this.state.selDistrictName}
                fetchData = {this.fetchData}
                setState={{filter:this._setFilter,state:this._setState,district:this._setDistrict,stateName:this._setStateName,districtName:this._setDistrictName,pin:this._setPin,isAgeFilter:this._setIsAgeFilter,ageFilter:this._setAgeFilter,isFeeFilter:this._setIsFeeFilter,feeFilter:this._setFeeFilter,isVaccineFilter:this._setIsVaccineFilter,vaccineFilter:this._setVaccineFilter}} 
              />
            </Segment>
            </Grid.Column>
            <Grid.Column style={{display:"grid"}}>
                <Segment compact textAlign="center">
                <Popup
                    hideOnScroll
                    trigger={
                        <Segment.Group className="controls-alert" compact>
                        <Segment>
                          <Radio label='Alert me here on vaccine available' toggle onChange={()=>this.setState((state)=>({alertOn:!state.alertOn}))} checked={this.state.alertOn}></Radio>
                        </Segment>
                        <Segment>
                          <Button className="btn-alert-snooze" onClick={this.onAlertSnooze} color="olive" disabled={!this.state.isAudioPlaying}>Stop alert</Button>
                        </Segment>
                      </Segment.Group>                  
                    }
                    content="Keep this browser running in background to receive alerts here"
                    position='top right'
                    on="hover"
                  />
                  <Segment>
                    <a href="/groups">
                    <Button color='twitter' size="big">
                      <Icon name='bell'/> Get instant alerts on Telegram
                    </Button>
                    </a>
                  </Segment>
                </Segment>
            </Grid.Column>
            </Grid.Row>
          </Grid>
          <div className="misc" style={{display:"flex",justifyContent:"center"}}>
            <audio id="audio" src="./alert2.mp3" type="audio/mp3"></audio>
          </div><hr/>
          <div className="main-table" style={{display:"none"}}>
            <Table definition unstackable>
              <Table.Header>
                <Table.Row>
                  {[...this.state.cols]}
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {[...this.state.rows]}
              </Table.Body>
            </Table>
          </div>
        <Header as="h2">
          <Icon name="hourglass half"/>&nbsp;
          Unable to find data :(
        </Header>
        </div>
        </Container>
      )}
      else{
        return(
          <Container fluid className="tableContainer">
          <div className="innerContainer">
          <Grid columns={2} doubling stackable>
            <Grid.Row centered>
            <Grid.Column style={{display:"grid"}}>
            <Segment compact textAlign="center">
            <Filters
                appState={this.state} 
                pin={this.state.pin}
                filter={this.state.selFilter} 
                state={this.state.selState} 
                stateName={this.state.selStateName} 
                district={this.state.selDistrict} 
                districtName={this.state.selDistrictName}
                fetchData = {this.fetchData}
                setState={{filter:this._setFilter,state:this._setState,district:this._setDistrict,stateName:this._setStateName,districtName:this._setDistrictName,pin:this._setPin,isAgeFilter:this._setIsAgeFilter,ageFilter:this._setAgeFilter,isFeeFilter:this._setIsFeeFilter,feeFilter:this._setFeeFilter,isVaccineFilter:this._setIsVaccineFilter,vaccineFilter:this._setVaccineFilter}} 
              />
              </Segment>
              </Grid.Column>
              <Grid.Column style={{display:"grid"}}>
                <Segment compact textAlign="center">
                <Popup
                    hideOnScroll
                    trigger={
                        <Segment.Group className="controls-alert" compact>
                        <Segment>
                          <Radio label='Alert me here on vaccine available' toggle onChange={()=>this.setState((state)=>({alertOn:!state.alertOn}))} checked={this.state.alertOn}></Radio>
                        </Segment>
                        <Segment>
                          <Button className="btn-alert-snooze" onClick={this.onAlertSnooze} color="olive" disabled={!this.state.isAudioPlaying}>Stop alert</Button>
                        </Segment>
                      </Segment.Group>                  
                    }
                    content="Keep this browser running in background to receive alerts here"
                    position='top right'
                    on="hover"
                  />
                  <Segment>
                    <a href="/groups">
                    <Button color='twitter' size="big">
                      <Icon name='bell'/> Get instant alerts on Telegram
                    </Button>
                    </a>
                  </Segment>
                </Segment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
            <div className="misc" style={{display:"flex",justifyContent:"center"}}>
              <audio id="audio" src="./alert2.mp3" type="audio/mp3"></audio>
            </div><hr/>
            <div className="main-table" style={{display:"none"}}>
              <Table definition unstackable>
                <Table.Header>
                  <Table.Row>
                    {[...this.state.cols]}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {[...this.state.rows]}
                </Table.Body>
              </Table>
            </div>
          <Header as="h2">
            <Icon name="exclamation"/>&nbsp;
            Please enter city pincode or district  ...
          </Header>
          </div>
          </Container>
        );
    }

  }

}

export default App;
